module.exports = __webpack_public_path__ + "img/Pariah_logo_black_256.70ef2c31.png";